export default {
    h5: {
        selectSignCompactUrl:
            "/gateway/huilianCust/compactcs/selectSignCompactUrl", //合同签署地址
        checkCertification:
            "/gateway/huilianCust/certificationcs/checkCertification", //校验是否实名
        selectCertificate: "/gateway/huilianCust/compactcs/selectCertificate",
    },
    wechat: {
        selectSignCompactUrl:
            "/gateway/huilianCust/compactcs/selectSignCompactUrl",
        checkCertification:
            "/gateway/huilianCust/certificationcs/checkCertification", //校验是否实名
        selectCertificate: "/gateway/huilianCust/compactcs/selectCertificate",
    },
};



// WEBPACK FOOTER //
// ./src/authCertificateCompact/ACFaceCa/api.js